import { Directive, Input, ElementRef, HostListener, Renderer2 } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SimpleDialogComponent } from '../shared/simple-dialog/simple-dialog.component';

@Directive({
    selector: '[tooltip]'
})
export class TooltipDirective {
    @Input('tooltip') tooltipTitle: string;
    @Input() placement: string;
    @Input() placementModal:any=0;
    @Input() delay: string;
    @Input() videoLink: string;
    @Input() videoTitle: string;
    @Input() customClass?: string;
    tooltip: HTMLElement;
    offset = 10;
    toggle: boolean = false;



    constructor(
        private el: ElementRef,
        private renderer: Renderer2,
        public dialog: MatDialog,) { }

    @HostListener('mouseenter') onMouseEnter() {
        if (!this.placement) {
            this.placement = 'right';
        }
        if (!this.tooltip && this.tooltipTitle!="hide_tool_tip") { this.show(); }
    }
    @HostListener('mouseleave') onMouseLeave() {
        if (this.tooltip) { this.hide(); }
    }
    @HostListener('click',) onClick() {
        if (!this.toggle) {
            if (!this.placement) {
                this.placement = 'right';
            }
            if (!this.tooltip && this.tooltipTitle!="hide_tool_tip") { this.show(); }
            this.toggle = true;
        } else {
            this.hide();
            this.toggle = false;
        }
    }

    show() {
        this.create();
        this.setPosition();
        this.renderer.addClass(this.tooltip, 'ng-tooltip-show');
    }

    hide() {
        if (this.renderer && this.tooltip && this.tooltip.classList) {
            this.renderer.removeClass(this.tooltip, 'ng-tooltip-show');
        }
        window.setTimeout(() => {
            if (this.tooltip) {
                const parent = this.placementModal == "1" ? document.body : this.el.nativeElement;
                this.renderer.removeChild(parent, this.tooltip);
            }
            this.tooltip = null;
        }, Number(this.delay));

    }

    create() {
        let placement = this.placement;
        const hostPos = this.el.nativeElement.getBoundingClientRect();
        this.tooltip = this.renderer.createElement('span');
       
        this.renderer.appendChild(
            this.tooltip,
            this.renderer.createText(this.tooltipTitle) // textNode
        );
        let path = window.location.pathname;     
        if (this.videoLink) {
            let more_info = this.renderer.createElement('p');
            if(path == '/app/finance'){
                this.renderer.appendChild(
                    more_info,
                    this.renderer.createText("How it works")
                );
            }else{
                this.renderer.appendChild(
                    more_info,
                    this.renderer.createText("For More Information")
                );
            }
            this.renderer.addClass(more_info, "for-more-info")
            let img = this.renderer.createElement("IMG");
            if(path == '/app/finance'){
                img.setAttribute("src", "assets/img/png/video-icon.png");
            }
            else{
                img.setAttribute("src", "assets/img/svg/play-btnn.svg");
            }
            img.setAttribute("width", "20");
            img.setAttribute("height", "20");
            img.setAttribute("alt", "tutorial video");
            img.style.marginLeft = '6px' 
            this.renderer.appendChild(more_info, img);
            this.renderer.appendChild(this.tooltip, more_info);
            this.renderer.listen(more_info, 'click', () => {
                this.openDialog();
            });
        }
        if(this.placementModal=="1"){
            this.renderer.appendChild(document.body, this.tooltip);
        }else{ 
            this.renderer.appendChild(this.el.nativeElement, this.tooltip);
        }
       
        this.renderer.addClass(this.tooltip, 'ng-tooltip');
        if (this.placement == "right") {
            if (hostPos.right > (window.innerWidth - 150)) {
                placement = "bottom";
            }
            else {
                let width = ((window.innerWidth - 20) - hostPos.right);
                this.renderer.setStyle(this.tooltip, 'width', `${width > 250 ? 250 : width}px`);
            }
        }
        this.renderer.addClass(this.tooltip, `ng-tooltip-${placement}`);
        if (this.customClass) {
            this.renderer.addClass(this.tooltip, `${this.customClass}`);
        }


        this.renderer.setStyle(this.tooltip, '-webkit-transition', `opacity ${this.delay}ms`);
        this.renderer.setStyle(this.tooltip, '-moz-transition', `opacity ${this.delay}ms`);
        this.renderer.setStyle(this.tooltip, '-o-transition', `opacity ${this.delay}ms`);
        this.renderer.setStyle(this.tooltip, 'transition', `opacity ${this.delay}ms`);
    }

    setPosition() {
        this.renderer.setStyle(this.el.nativeElement, 'position', 'relative');
        this.renderer.setStyle(this.tooltip, 'position', 'fixed');
        const hostPos = this.el.nativeElement.getBoundingClientRect();
        const tooltipPos = this.tooltip.getBoundingClientRect();
        let top, left;
        if (this.placement === 'top') {
            top = hostPos.top - tooltipPos.height - this.offset;
            left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
        }
        if (this.placement === 'bottom') {
            let left_pos = ((hostPos.right - (hostPos.width / 2)) + tooltipPos.width / 2);
            top = hostPos.bottom + this.offset;
            if (left_pos > window.innerWidth) {
                left = (hostPos.left + (hostPos.width - tooltipPos.width) / 2) - (left_pos-window.innerWidth);
            }
            else {
                left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
            }
            this.renderer.setAttribute(this.tooltip, `data-left-post`, left + "px");
        }
        if (this.placement === 'left') {
            top = hostPos.top + (hostPos.height - tooltipPos.height) / 2;
            left = hostPos.left - tooltipPos.width - this.offset;
        }
        if (this.placement === 'right') {
            if (hostPos.right > (window.innerWidth - 150)) {
                let left_pos = ((hostPos.right - (hostPos.width / 2)) + tooltipPos.width / 2);
                top = hostPos.bottom + this.offset;
                if (left_pos > window.innerWidth) {
                    left = (hostPos.left + (hostPos.width - tooltipPos.width) / 2) - (left_pos-window.innerWidth);
                }
                else {
                    left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
                }
            }
            else {
                top = hostPos.top + (hostPos.height - tooltipPos.height) / 2;
                left = hostPos.right + this.offset;
            }
        }
        this.renderer.setStyle(this.tooltip, 'top', `${top}px`);
        this.renderer.setStyle(this.tooltip, 'left', `${left}px`);
    }
    openDialog() {
        this.dialog.open(SimpleDialogComponent, {
            width: '950px',
            panelClass: 'simpleDialog',
            data: {
                type: 214,
                title: this.videoTitle,
                url: this.videoLink
            }
        });
    }


    
}
